import React, { useEffect, useState } from 'react';

const DownloadRedirect = () => {
  const [storeLink, setStoreLink] = useState("https://play.google.com/store/apps/details?id=com.kwikmedia&hl=en_IN");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const targetLink = isIOS 
      ? "https://apps.apple.com/in/app/kwikmemories/id6717602527" 
      : "https://play.google.com/store/apps/details?id=com.kwikmedia&hl=en_IN";
    
    setStoreLink(targetLink);
    window.location.replace(targetLink);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#ffffff',
      fontFamily: "'Poppins', sans-serif",
      color: '#121212',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h2 style={{ marginBottom: '12px', fontWeight: 600 }}>Redirecting to Store...</h2>
      <p style={{ color: '#666', fontSize: '16px' }}>
        If you are not redirected automatically,{' '}
        <a href={storeLink} style={{ color: '#c94daa', textDecoration: 'underline', fontWeight: 500 }}>
          click here
        </a>.
      </p>
    </div>
  );
};

export default DownloadRedirect;
